<template>
    <div class="chat-box create-chat">
        <div class="chat-box-header">

            <div class="chat-box-header__top">
                <back-button class="chat-box-header__back" @click.native="back">{{ $t("common.back") }}</back-button>
                <div class="chat-box-header__title">
                    <span>{{ $t('common.new message') }}</span>
                </div>
                <div class="chat-box-header__flex-box-stub"></div>
            </div>

        </div>
        <div class="chat-box-body" ref="body">
            <search-bar v-model="searchString"></search-bar>
            <div class="creat-chat-spinner" v-if="loading">
                <spinner></spinner>
            </div>
            <div class="chat-create-users-list">
                    <user v-for="user in list"
                          :key="user.id"
                          :user="user"
                          @click.native="select(user)"
                          class="create-chat-user"/>

                <transition name="fade">
                    <div class="creat-chat-spinner-bottom" v-if="pageLoading">
                        <spinner></spinner>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import SearchBar from "./SearchBar";
    import Spinner from "../Spinner";
    import User from "../user/User";
    import BackButton from "../../../../service/components/common/back-button/BackButton.vue";
    import debounce from 'lodash.debounce';

    export default {
        name: "CreateChat",
        components: {
            SearchBar, Spinner, User, BackButton
        },
        data() {
          return {
              loading: false,
              pageLoading: false,
              page: 1,
              list: [],
              noMoreData: false,
              searchString: ''
          }
        },
        methods: {
            back() {
                this.$emit('back');
            },
            loadData() {
                const params = this.$store.getters['events/selectedEventViewParam']('participants', null);

                this.$store.dispatch('chat/profiles/searchProfiles', {
                    page: this.page,
                    search: this.searchString,
                    groupIds: params?.groupIds
                })
                    .then(profiles => {
                        if (profiles && profiles.length == 0) {
                            this.noMoreData = true;
                        }
                        this.list = this.list.concat(profiles);
                        this.loading = false;
                        this.pageLoading = false;
                    })
                    .catch(e => {
                        //@todo chat notification
                        this.$store.dispatch('reportException', e, {root: true});
                        this.loading = false;
                        this.pageLoading = false;
                    })

            },
            search: debounce(function () {
                this.noMoreData = false;
                this.loading = true;
                this.list = [];
                this.page = 1;
                this.loadData();
            }, 300),
            nextPage() {
                this.page++;
                this.pageLoading = true;
                this.loadData();
            },
            onScroll() {
                if (!this.noMoreData &&
                    (this.$refs['body'].scrollTop + this.$refs['body'].clientHeight) === this.$refs['body'].scrollHeight &&
                    !this.pageLoading) {
                   this.nextPage();
                }
            },
            select(user) {
                this.loading = true;
                this.$store.dispatch('chat/rooms/createDirectRoom', user)
                    .then(room => {
                        this.$emit('selectRoom', room);
                    })
                    .catch(e => {
                        //@todo chat notification
                        this.loading = false;
                        this.$store.dispatch('reportException', e, {root: true});
                    })
            }
        },
        watch: {
            searchString(value) {
                this.search(value);
            }
        },
        destroyed() {
            this.$refs['body'] && this.$refs['body'].removeEventListener('scroll', this.onScroll);
        },
        mounted() {
            this.loading = true;
            this.loadData();
            this.$refs['body'].addEventListener('scroll', this.onScroll);
        }
    }
</script>

<style scoped>

</style>